module.exports = __webpack_public_path__ + "static/media/MO.67117024.svg";